import siteMessage from "@insite/client-framework/SiteMessage";

/* Type for the object that will be passed to validate function as the first parameter */
export type InputObjectType = {
    name: string;
    value: string;
};

/*
    Function signature for callback function.
    This function will accept object of type 'InputObjectType' and return a string which will be an error message
*/
export type CallbackType = (input: InputObjectType) => string;

/* Type for the different validation constraints, label property is mandatory while others are optional */
export type ValidatorRuleType = {
    required?: boolean;
    minLength?: number;
    legalNameMinLength?: number;
    multiFamilylegalNameMinLength?: number;
    doingBussinessAsDBAMinLength?: number;
    taxIdMinLength?: number;
    multiFamilyTaxIdMinLength?: number;
    multiFamilyPhysicalAddressNameMinLength?: number;
    multiFamilyPhysicalAddressCityMinLength?: number;
    multiFamilyPhysicalAddressStateMinLength?: number;
    multiFamilyPhysicalAddressZipMinLength?: number;
    multiFamilyMailingAddressNameMinLength?: number;
    multiFamilyMailingAddressCityMinLength?: number;
    multiFamilyMailingAddressStateMinLength?: number;
    multiFamilyMailingAddressZipMinLength?: number;
    multiFamilyAccountingNameMinLength?: number;
    multiFamilyAuthorizedBuyersMinLength?: number;
    multiFamilyPropertyInformationNameMinLength?: number;
    multiFamilyPropertyInformationWebAddressMinLength?: number;
    multiFamilyPropertyInformationAddressMinLength?: number;
    multiFamilyPropertyInformationCityMinLength?: number;
    multiFamilyPropertyInformationStateMinLength?: number;
    multiFamilyPropertyInformationZipMinLength?: number;
    multiFamilyPropertyInformationOwnerNameMinLength?: number;
    multiFamilyPropertyInformationOwnerPhoneNumberMinLength?: number;
    multiFamilyPropertyInformationOwnerAddressMinLength?: number;
    multiFamilyPropertyInformationOwnerCityMinLength?: number;
    multiFamilyPropertyInformationOwnerStateMinLength?: number;
    multiFamilyPropertyInformationOwnerZipMinLength?: number;
    multiFamilyPropertyInformationOwnerContactMinLength?: number;
    physicalAddressMinLength?: number;
    billToNameMinLength?: number;
    billToAddressMinLength?: number;
    billToWebAddressMinLength?: number;
    contractorLicenseMinLength?: number;
    authorizedBuyersMinLength?: number;
    principleOwnerTitleMinLength?: number;
    principleOwnerAddressMinLength?: number;
    firstNameMinLength?: number;
    lastNameMinLength?: number;
    titleMinLength?: number;
    existingfirstNameMinLength?: number;
    existinglastNameMinLength?: number;
    maxLength?: number;
    accountingPhoneMaxLength?: number;
    regex?: RegExp;
    creditApplicationBillToEmailregex?: RegExp;
    creditApplicationAccontingEmailregex?: RegExp;
    creditApplicationMethodOfInvoicingEmailregex?: RegExp;
    creditApplicationPropertyInformationOwnerEmailregex?: RegExp;
    existingCustomerEmailregex?: RegExp;
    customValidation?: boolean;
    requiredMsg?: string;
    minLengthMsg?: string;
    maxLengthMsg?: string;
    regexMsg?: string;
    // label?: string;
    label?: any;
};

/* Type for the error object */
export type ErrorObjectType = {
    errorCode: string | undefined; // optional
    errorMsg: string | undefined;
};

type ValidatorTypes = boolean | string | number | RegExp;

/* Utility function to check the empty value. */
export const isEmpty = (value: string) => value.trim().length <= 0;

/*
    This function is reponsibled to handle the password validation.
    This accepts 2 arguments, password and confirmPassword and return undefined if data is valid.
    Invalid data will return error object which will of type  ErrorObjectType
*/
export const validatePasswordHandler = (pwd: string, confirmPwd: string) => {
    if (pwd === "") {
        return {
            errorCode: "required",
            errorMsg: `${siteMessage("create_account_new_customer_registration_password")}`,
        };
    }

    // if (pwd.length < 8) {
    //     return {
    //         errorCode: "passwordnotmatch",
    //         errorMsg: "Password should have at least 8 characters.",
    //     };
    // }
    // -----------------

    if (!/^[^:%&?]+$/.test(pwd)) {
        return {
            errorCode: "passwordspecialcharacter",
            errorMsg: `${siteMessage("create_account_new_customer_registration_passwordRemoveSpecialCharacter")}`,
        };
    }

    // if (!/^[^:%&?]+$/.test(pwd)) {
    //     return {
    //         errorCode: "passwordspecialcharacter",
    //         errorMsg: "Password should not contain '%' ,'?', '&' and ':' special characters.",
    //     };
    // }

    // For Checking condition that Password must contain a minimum of 8 characters, including one number & one special character.
    if (!/^(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/.test(pwd)) {
        return {
            errorCode: "passwordspecialcharacter",
            errorMsg: `${siteMessage("create_account_new_customer_registration_passwordAddSpecialCharacter")}`,
        };
    }

    // For checking Password filed with confirm password matching or  not

    if (!!pwd && !!confirmPwd && pwd !== confirmPwd) {
        return {
            errorCode: "passwordnotmatch",
            errorMsg: `${siteMessage("create_account_new_customer_registration_passwordnotmatch")}`,
        };
    }

    // -----------------------------
    // if (!/^(?=.*\W)$/.test(pwd)) {
    //     return {
    //         errorCode: "passwordspecialcharacter",
    //         errorMsg: "Password must contain one special character.",
    //     };
    // }

    // if (!/^(?=.*[0-9])$/.test(pwd)) {
    //     return {
    //         errorCode: "passwordspecialcharacter",
    //         errorMsg: "Password must contain one Digit.",
    //     };
    // }
    // -----------------------------
};

/*
    This function is reponsibled to handle the password validation.
    This accepts 2 arguments, password and confirmPassword and return undefined if data is valid.
    Invalid data will return error object which will of type  ErrorObjectType
*/
export const validateConfirmPasswordHandler = (pwd: string, confirmPwd: string) => {
    if (confirmPwd === "") {
        return {
            errorCode: "required",
            errorMsg: `${siteMessage("create_account_new_customer_registration_ConfirmPasswordRequired")}`,
        };
    }
    if (!!pwd && !!confirmPwd && pwd !== confirmPwd) {
        return {
            errorCode: "passwordnotmatch",
            errorMsg: `${siteMessage("create_account_new_customer_registration_PasswordsDoNotMatch")}`,
        };
    }
};

/*
    This function will accept the constraint type, constraint value, inputObject and callback function
    Invalid data will return error object which will of type  ErrorObjectType.
    Valid data will return undefined.
*/
const validateField = (
    validationRule: string,
    validationValue: ValidatorTypes,
    input: InputObjectType,
    callback: CallbackType,
    errorLabel: string,
    configObject: ValidatorRuleType,
) => {
    const errorObject: ErrorObjectType = {
        errorCode: undefined,
        errorMsg: undefined,
    };

    switch (validationRule) {
        case "required": {
            if (isEmpty(input.value)) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.requiredMsg ? configObject.requiredMsg : `${errorLabel}`;
            }
            break;
        }
        case "minLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                const customizeError = errorLabel.replace("required", "");
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${customizeError} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "firstNameMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_firstName",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "legalNameMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_creditApplication_legalName",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilylegalNameMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_legalName",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "doingBussinessAsDBAMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_creditApplication_doingBussinessAsDBA",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "taxIdMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_creditApplication_taxId",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyTaxIdMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_taxId",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyPhysicalAddressNameMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_physicalAddressName",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyPhysicalAddressCityMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_physicalAddressCity",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyPhysicalAddressStateMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_physicalAddressState",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyPhysicalAddressZipMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_physicalAddressZip",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyMailingAddressNameMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_mailingAddressName",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyMailingAddressCityMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_mailingAddressCity",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyMailingAddressStateMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_mailingAddressState",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyMailingAddressZipMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_mailingAddressZip",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyAccountingNameMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_accountingName",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyAuthorizedBuyersMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_authorizedBuyers",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyPropertyInformationNameMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_propertyInformationName",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyPropertyInformationWebAddressMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_propertyInformationWebAddress",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyPropertyInformationAddressMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_propertyInformationAddress",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyPropertyInformationCityMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_propertyInformationCity",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyPropertyInformationStateMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_propertyInformationState",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyPropertyInformationZipMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_propertyInformationZip",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyPropertyInformationOwnerNameMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_propertyInformationOwnerName",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyPropertyInformationOwnerPhoneNumberMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_propertyInformationOwnerPhoneNumber",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyPropertyInformationOwnerAddressMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_propertyInformationOwnerAddress",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyPropertyInformationOwnerCityMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_propertyInformationOwnerCity",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyPropertyInformationOwnerStateMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_propertyInformationOwnerState",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyPropertyInformationOwnerZipMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_propertyInformationOwnerZip",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "multiFamilyPropertyInformationOwnerContactMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_propertyInformationOwnerContact",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "physicalAddressMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_creditApplication_physicalAddress",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "billToNameMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_creditApplication_billToName",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "billToAddressMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_creditApplication_billToAddress",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "billToWebAddressMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_creditApplication_billToWebAddress",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "contractorLicenseMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_creditApplication_contractorLicense",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "authorizedBuyersMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_creditApplication_authorizedBuyers",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "principleOwnerTitleMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_creditApplication_principleOwnerTitle",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "principleOwnerAddressMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_creditApplication_principleOwnerAddress",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "existingfirstNameMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_existing_customer_registration_firstName",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "existinglastNameMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_existing_customer_registration_lastName",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "lastNameMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_lastName",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "titleMinLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.minLengthMsg
                    ? configObject.minLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_title",
                      )} should contain at least ${validationValue} characters`;
            }
            break;
        }
        case "maxLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.maxLengthMsg
                    ? configObject.maxLengthMsg
                    : `${siteMessage("create_account_new_customer_registration_phone")}`;
            }
            break;
        }
        case "accountingPhoneMaxLength": {
            if (input.value.length < validationValue) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.maxLengthMsg
                    ? configObject.maxLengthMsg
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_accountingPhone",
                      )}`;
            }
            break;
        }
        case "regex": {
            if (!(<RegExp>validationValue).test(input.value)) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.regexMsg
                    ? `${siteMessage("create_account_new_customer_registration_email")}`
                    : `${siteMessage("create_account_new_customer_registration_email")}`;
            }
            break;
        }
        case "creditApplicationBillToEmailregex": {
            if (!(<RegExp>validationValue).test(input.value)) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.regexMsg
                    ? `${siteMessage("create_account_new_customer_registration_creditApplication_billToEmail")}`
                    : `${siteMessage("create_account_new_customer_registration_creditApplication_billToEmail")}`;
            }
            break;
        }
        case "creditApplicationAccontingEmailregex": {
            if (!(<RegExp>validationValue).test(input.value)) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.regexMsg
                    ? `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_accountingEmail",
                      )}`
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_accountingEmail",
                      )}`;
            }
            break;
        }
        case "creditApplicationMethodOfInvoicingEmailregex": {
            if (!(<RegExp>validationValue).test(input.value)) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.regexMsg
                    ? `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_methodOfInvoicingEmail",
                      )}`
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_methodOfInvoicingEmail",
                      )}`;
            }
            break;
        }
        case "creditApplicationPropertyInformationOwnerEmailregex": {
            if (!(<RegExp>validationValue).test(input.value)) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.regexMsg
                    ? `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_propertyInformationOwnerEmail",
                      )}`
                    : `${siteMessage(
                          "create_account_new_customer_registration_multiFamilyCreditApplication_propertyInformationOwnerEmail",
                      )}`;
            }
            break;
        }
        case "existingCustomerEmailregex": {
            if (!(<RegExp>validationValue).test(input.value)) {
                errorObject.errorCode = validationRule;
                errorObject.errorMsg = configObject.regexMsg
                    ? `${siteMessage("create_account_existing_customer_registration_email")}`
                    : `${siteMessage("create_account_existing_customer_registration_email")}`;
            }
            break;
        }
        case "customValidation": {
            if (callback) {
                const validationMsg = callback({ name: input.name, value: input.value });
                if (validationMsg) {
                    errorObject.errorCode = `customValidation`;
                    errorObject.errorMsg = validationMsg;
                }
            }
            break;
        }
        default: {
            break;
        }
    }

    return errorObject.errorCode === undefined ? undefined : errorObject;
};

/*
    This method will accept the input/select element as the first parameter which is mandatory. Second
    parameter is optional which accepts a callback function. This callback function should be passed only
    when custom validation is required. Callback function should return an empty string when the validation
    pass else throws an error message.
*/
export const validate = (
    input: InputObjectType,
    validatorConfig: ValidatorRuleType,
    callback?: CallbackType,
): ErrorObjectType | undefined => {
    if (!input || (input && !input.name)) {
        return;
    }

    const configObject = validatorConfig;
    const errorLabel: string = configObject.label || "";
    let isError: ErrorObjectType | undefined;
    if (callback) {
        configObject.customValidation = true;
    }
    const skipValidations = ["label", "requiredMsg", "minLengthMsg", "maxLengthMsg", "customMsg"];
    Object.keys(configObject).every(key => {
        if (skipValidations.indexOf(key) === -1) {
            isError = validateField(
                key,
                <ValidatorTypes>configObject[key as keyof ValidatorRuleType],
                input,
                <CallbackType>callback,
                errorLabel,
                configObject,
            );
            if (isError !== undefined) {
                return false;
            }
        }
        return true;
    });

    return isError === undefined ? undefined : isError;
};
